export default {"src":"/_next/static/media/ArticleIcon.d02d4f6f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};